import { User } from '../user';
import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class UpdateSerializer extends BaseSerializer {
  deserialize(raw) {
    console.log("🚀 ~ UpdateSerializer ~ deserialize ~ raw:", raw)
    // Nouveau format: { statusCode: 200, message: "...", data: {...} }
    const success = raw?.statusCode === 200;
    let parsedUser = null;
    if (success && raw?.data) {
      const data = raw.data;
      parsedUser = {
        id: data.id || data._id,
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        phoneNumber: data.phoneNumber || data.phone || '',
        countryCode: data.countryCode,
        createdAt: data.createdAt,
        updatedAt: data.updatedAt,
        metadata: data.metadata || { service: 'rapidoo' },
        favoriteRestaurants: data.favoriteRestaurants || [],
        favoriteDishes: data.favoriteDishes || [],
        profilePictureUrl: data.metadata?.avatar
      };
    }

    const errorTexts = success
      ? null
      : errorMessages[`${raw?.statusCode}`] || errorMessages.other;
    return {
      success,
      statusCode: raw?.statusCode || 500,
      message: success ? 'ok' : errorTexts?.message,
      errorTitle: errorTexts?.title,
      user: success ? new User(parsedUser) : null
    };
  }

  serialize(data) {
    if (!data) return null;

    const serialized = {
      email: data.email
    };

    const profile = {};
    let hasProfileUpdate = false;

    if (data.firstName) {
      profile.firstName = data.firstName;
      hasProfileUpdate = true;
    }
    if (data.lastName) {
      profile.lastName = data.lastName;
      hasProfileUpdate = true;
    }
    if (data.avatar || data.profilePictureUrl) {
      profile.avatar = data.avatar || data.profilePictureUrl;
      hasProfileUpdate = true;
    }

    if (hasProfileUpdate) {
      serialized.profile = profile;
    }

    if (data.password) serialized.password = data.password;
    if (data.metadata) serialized.metadata = data.metadata;

    return serialized;
  }
}

const errorMessages = {
  401: {
    title: 'Non autorisé',
    message: "Vous n'êtes pas autorisé à effectuer cette modification."
  },
  404: {
    title: 'Utilisateur introuvable',
    message: 'Aucun utilisateur ne correspond à cet email.'
  },
  400: {
    title: 'Erreur dans les données',
    message:
      'Les informations soumises sont invalides. Veuillez vérifier et réessayer.'
  },
  other: {
    title: "Échec de la mise à jour",
    message: 'Une erreur inattendue s\'est produite. Veuillez réessayer.'
  }
};

export const updateSerializer = new UpdateSerializer();
